var _path, _path2, _path3, _g, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 145,
    viewBox: "0 0 132 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_366_56715)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_366_56715",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 132,
    height: 145
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M132 0H0V145H132V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_366_56715)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9997 31.4287C88.6425 31.4287 107.027 49.8328 107.027 72.5001C107.027 95.1675 88.6425 113.572 65.9997 113.572C43.3569 113.572 24.9727 95.1675 24.9727 72.5001C24.9727 49.8328 43.3569 31.4287 65.9997 31.4287Z",
    stroke: "#F20505",
    strokeWidth: 10
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_366_56715",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 132,
    height: 145
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H132V145H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_366_56715)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.505 21.4153C122.367 19.2796 122.571 13.9268 122.571 13.9268C122.571 13.9268 122.775 19.2796 120.637 21.4153C118.5 23.551 113.143 23.3475 113.143 23.3475C113.143 23.3475 118.5 23.1439 120.637 25.2796C122.775 27.4153 122.571 32.7682 122.571 32.7682C122.571 32.7682 122.367 27.4153 124.505 25.2796C126.642 23.1439 131.999 23.3475 131.999 23.3475C131.999 23.3475 126.642 23.551 124.505 21.4153Z",
    fill: "#F20505"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8118 16.3441C33.3509 11.887 33.7769 0.714844 33.7769 0.714844C33.7769 0.714844 34.2029 11.887 29.742 16.3441C25.2811 20.8013 14.0996 20.3756 14.0996 20.3756C14.0996 20.3756 25.2811 19.9498 29.742 24.407C34.2029 28.8641 33.7769 40.0363 33.7769 40.0363C33.7769 40.0363 33.3509 28.8641 37.8118 24.407C42.2727 19.9498 53.4542 20.3756 53.4542 20.3756C53.4542 20.3756 42.2727 20.8013 37.8118 16.3441Z",
    fill: "#F20505"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1463 115.878C23.663 110.399 24.1867 96.667 24.1867 96.667C24.1867 96.667 24.7104 110.399 19.227 115.878C13.7437 121.356 0 120.833 0 120.833C0 120.833 13.7437 120.311 19.227 125.789C24.7104 131.268 24.1867 145 24.1867 145C24.1867 145 23.663 131.268 29.1463 125.789C34.6297 120.311 48.3726 120.833 48.3726 120.833C48.3726 120.833 34.6297 121.356 29.1463 115.878Z",
    fill: "#F20505"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4906 124.521C63.3006 124.521 64.7703 125.989 64.7703 127.797C64.7703 129.606 63.3006 131.074 61.4906 131.074C59.6806 131.074 58.2109 129.606 58.2109 127.797C58.2109 125.989 59.6806 124.521 61.4906 124.521Z",
    fill: "#F20505"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9697 7.32422C73.8747 7.32422 74.6094 8.05846 74.6094 8.96279C74.6094 9.86712 73.8747 10.6014 72.9697 10.6014C72.0648 10.6014 71.3301 9.86712 71.3301 8.96279C71.3301 8.05846 72.0648 7.32422 72.9697 7.32422Z",
    fill: "#F20505"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.262 43.4189C128.524 43.4189 130.361 45.2544 130.361 47.515C130.361 49.7756 128.524 51.6111 126.262 51.6111C123.999 51.6111 122.162 49.7756 122.162 47.515C122.162 45.2544 123.999 43.4189 126.262 43.4189Z",
    fill: "#F20505"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7268 36.8652C23.3104 36.8652 24.5962 38.15 24.5962 39.7324C24.5962 41.3148 23.3104 42.5995 21.7268 42.5995C20.1432 42.5995 18.8574 41.3148 18.8574 39.7324C18.8574 38.15 20.1432 36.8652 21.7268 36.8652Z",
    fill: "#F20505"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.636 102.401C120.767 102.401 121.685 103.319 121.685 104.449C121.685 105.579 120.767 106.497 119.636 106.497C118.504 106.497 117.586 105.579 117.586 104.449C117.586 103.319 118.504 102.401 119.636 102.401Z",
    fill: "#F20505"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8326 57.114L81.0781 81.3858C82.6575 82.9669 82.7741 85.4177 81.3383 86.8551C79.9025 88.2925 77.4543 88.1758 75.8749 86.5947L51.6293 62.3229C50.0499 60.7418 49.9334 58.291 51.3692 56.8536C52.805 55.4162 55.2532 55.5329 56.8326 57.114Z",
    fill: "#F20505"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8781 61.5175L56.6516 86.7714C55.2594 88.1651 52.9986 88.1651 51.6063 86.7714C50.2141 85.3776 50.2141 83.1144 51.6063 81.7206L76.8328 56.4668C78.2251 55.073 80.4859 55.073 81.8781 56.4668C83.2704 57.8605 83.2704 60.1238 81.8781 61.5175Z",
    fill: "#F20505"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_366_56715"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 132,
    height: 145,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentFailed);
export default __webpack_public_path__ + "static/media/payment-failed.ba4b87b6.svg";
export { ForwardRef as ReactComponent };